
export default {
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: () => ({
        statusCode: 500,
        message: '予期しないエラーが発生しました'
      })
    }
  },
  computed: {
    isPC() {
      // storeが存在しない場合やdeviseが未初期化の場合でも動作するようにする
      try {
        return this.$store && this.$store.state && this.$store.state.devise && this.$store.state.devise.isPC
      } catch (e) {
        // デフォルトはSPと判定
        return false
      }
    },
    isLoggedIn() {
      // ログイン状態を確認（storeが存在しない場合はfalse）
      try {
        return this.$store && this.$store.getters && this.$store.getters['auth/isLogin']
      } catch (e) {
        return false
      }
    }
  }
}
